export const homePage = 5;
export const legalNoticePage = 7;
export const privacyPage = 6;
